import Vue from "vue";
const VueSimpleSuggest = require("vue-simple-suggest/dist/cjs");

Vue.component("vue-simple-suggest", VueSimpleSuggest);
